import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ACTION_LABELS, FIELD_LABELS, formatDate, valueLabel as baseLabel } from "@/lib/labels";

const valueLabel = (v) => {
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T/.test(v)) return formatDate(v);
  if (v === "nisn" || v === "nip") return v.toUpperCase();
  return baseLabel(v);
};
import { EmptyState } from "./States";

const Diff = ({ before, after }) => {
  const keys = [...new Set([...Object.keys(before || {}), ...Object.keys(after || {})])].filter((k) => FIELD_LABELS[k]);
  if (!keys.length) return <span className="text-muted-foreground">—</span>;
  return (
    <ul className="space-y-0.5">
      {keys.map((k) => (
        <li key={k} className="text-xs">
          <span className="text-muted-foreground">{FIELD_LABELS[k]}: </span>
          {before && k in before && <><span className="line-through opacity-70">{valueLabel(before[k])}</span> → </>}
          <span className="font-medium">{valueLabel(after?.[k])}</span>
        </li>
      ))}
    </ul>
  );
};

export const AuditTable = ({ items }) => {
  if (!items.length) return <EmptyState title="Belum ada catatan audit" description="Tindakan penting seperti perubahan status, peran, dan undangan akan tercatat otomatis di sini." />;
  return (
    <>
    <ul className="lg:hidden space-y-3" data-testid="audit-cards">
      {items.map((a) => (
        <li key={a.id} className="rounded-xl border bg-card p-4 space-y-1">
          <div className="flex items-start justify-between gap-2">
            <p className="font-semibold text-sm">{ACTION_LABELS[a.action] || a.action}</p>
            {a.result === "denied" && <span className="text-xs font-semibold text-[#E11D2E]">Ditolak</span>}
          </div>
          <p className="text-xs text-muted-foreground">{formatDate(a.at)} · {a.actor_email || "Sistem"}</p>
          <p className="text-sm">{a.target_label || "—"}</p>
          <Diff before={a.before} after={a.after} />
          {a.reason && <p className="text-xs"><span className="text-muted-foreground">Alasan:</span> {a.reason}</p>}
        </li>
      ))}
    </ul>
    <div className="hidden lg:block rounded-xl border overflow-x-auto">
      <Table data-testid="audit-table">
        <TableHeader>
          <TableRow><TableHead>Waktu</TableHead><TableHead>Aksi</TableHead><TableHead>Pelaku</TableHead><TableHead>Target</TableHead><TableHead>Perubahan</TableHead><TableHead>Alasan</TableHead></TableRow>
        </TableHeader>
        <TableBody>
          {items.map((a) => (
            <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
              <TableCell className="text-xs whitespace-nowrap">{formatDate(a.at)}</TableCell>
              <TableCell>
                <span className="font-medium">{ACTION_LABELS[a.action] || a.action}</span>
                {a.result === "denied" && <span className="ml-2 text-xs font-semibold text-[#E11D2E]">Ditolak</span>}
              </TableCell>
              <TableCell className="text-xs">{a.actor_email || "Sistem"}</TableCell>
              <TableCell className="text-sm max-w-[200px] break-words" title={a.target_id}>{a.target_label || "—"}</TableCell>
              <TableCell><Diff before={a.before} after={a.after} /></TableCell>
              <TableCell className="text-xs max-w-[220px]">{a.reason || "—"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
    </>
  );
};
